import { createAction, props } from '@ngrx/store';

export const searchDocuments = createAction(
  '[Search Documents] Get Documents',
  props<{
    categoryId: number;
    language: string;
    filterIds?: number[];
    searchTerm?: string;
    limit?: number;
    page?: number;
    searchType?: string;
    sort?: string;
  }>(),
);

export const loadDocumentsSuccess = createAction('[Search Documents] Get Documents Success', props<{ data: any }>());

export const loadDocumentsFailure = createAction('[Search Documents] Get Documents Failure', props<{ error: any }>());

export const resetSearchDocuments = createAction('[Search Documents] Reset Search Documents');

export const updateSearchDocumentBookmark = createAction(
  '[Search Documents] Update Search Document Bookmark',
  props<{ documentId: number; isBookmarked: boolean }>(),
);
